import { render, staticRenderFns } from "./quote-list.vue?vue&type=template&id=1b717a5e&"
import script from "./quote-list.vue?vue&type=script&lang=ts&"
export * from "./quote-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports